import { render, staticRenderFns } from "./partner-form.vue?vue&type=template&id=4a3cf64c&scoped=true&"
import script from "./partner-form.vue?vue&type=script&lang=js&"
export * from "./partner-form.vue?vue&type=script&lang=js&"
import style0 from "./partner-form.vue?vue&type=style&index=0&id=4a3cf64c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3cf64c",
  null
  
)

export default component.exports